import { Color } from "three"

// Deepest shaded base
export const desertShadow = new Color(0x3E2B1F) // almost rock

// Lower canyon floor sand
export const canyonFloor = new Color(0x6B3E26)

// Middle slope (warm midtone)
export const midSlope = new Color(0xB17544)

// Upper sunny slope
export const sunSlope = new Color(0xD9A066)

// Crest/top of dunes
export const duneTop = new Color(0xF4D7A1)

/**
 * Returns a sand colour for arid desert terrain, given a normalised height y ∈ [-1, 1].
 *
 * Ranges (mirrors the shoal function):
 *   y ≥ 1      → paleAlmond
 *   0 ≤ y < 1  → lerp(duneTan,     paleAlmond)
 *  -0.5≤ y < 0 → lerp(dustyOchre,  duneTan)
 *  -1 ≤ y < ‑0.5 → lerp(burntClay, dustyOchre)
 *   y < ‑1     → desertShadow
 *
 * @param y        Normalised height in [-1, 1]
 * @param outColor Pre‑allocated THREE.Color to store the result
 */
export default function getDesertSandColor2(y: number, outColor: Color): void {
  let colorA: Color, colorB: Color
  let t: number

  if (y >= 0.25) {
    colorA = sunSlope
    colorB = duneTop
    t = (y - 0.25) / 0.75
  } else if (y >= -0.25) {
    colorA = midSlope
    colorB = sunSlope
    t = (y + 0.25) / 0.5
  } else if (y >= -0.75) {
    colorA = canyonFloor
    colorB = midSlope
    t = (y + 0.75) / 0.5
  } else if (y >= -1.0) {
    colorA = desertShadow
    colorB = canyonFloor
    t = (y + 1.0) / 0.25
  } else {
    outColor.copy(desertShadow)
    return
  }

  outColor.lerpColors(colorA, colorB, t)
}
